import styles from "../Library.module.css";

import { Loading } from "gui/loading/loading";
import List from "gui/BrowseQueriesPage/List/QueriesList";
import EmptyBecausePageIsOutOfBounds from "gui/browse-shared/EmptyBecausePageIsOutOfBounds";
import BrowsePagination, {
  usePaginationState,
} from "gui/browse-shared/BrowsePagination";

import { transformData } from "gui/BrowseQueriesPage/api/listBrowseQueries";

import { Torus008 } from "components/Illustrations/Torus008";
import { ContainedMessage } from "components/SectionMessage/ContainedMessage";
import useListMyQueries from "./api/useListMyQueries";
import { AnchorButton } from "components/Button/AnchorButton";
import { SessionWithUser } from "lib/users/types";
import { ApiParams } from "../Library";

export function QueriesResults(props: {
  session: SessionWithUser;
  apiParams: ApiParams;
  hasFiltersApplied: boolean;
}) {
  const { apiParams, session } = props;
  const [page] = usePaginationState();
  const queriesResult = useListMyQueries(apiParams, session);

  if (queriesResult.error) {
    return <section>Error</section>;
  }
  if (queriesResult.data) {
    const data = transformData(queriesResult.data);

    if (data.total_count === 0) {
      return <NoResults hasFiltersApplied={props.hasFiltersApplied} />;
    }

    // Check if page from url is out of bounds.
    // Consider there to always be at least one page, even if it's empty.
    const lastPage = Math.max(
      1,
      Math.ceil(data.total_count / apiParams.pageSize)
    );

    if (page > lastPage) {
      return <EmptyBecausePageIsOutOfBounds lastPage={lastPage} />;
    }

    return (
      <>
        <List queries={data.queries} origin={"creations"} />

        <BrowsePagination
          pageSize={apiParams.pageSize}
          totalCount={data.total_count}
        />
      </>
    );
  }
  if (queriesResult.loading) {
    return <Loading />;
  }

  return <Loading />;
}

function NoResults({ hasFiltersApplied }: { hasFiltersApplied: boolean }) {
  return (
    <div className={styles.emptyState}>
      <ContainedMessage
        heading={
          hasFiltersApplied
            ? "There are no queries matching selected filters"
            : "No queries yet!"
        }
        body={!hasFiltersApplied && "Queries you create will show up here."}
        image={<Torus008 />}
        actions={
          <>
            <AnchorButton size="M" theme="primary" href="/queries">
              New query
            </AnchorButton>
            {hasFiltersApplied && (
              <AnchorButton
                size="M"
                theme="tertiary"
                href="/workspace/library?tab=queries"
              >
                Show all
              </AnchorButton>
            )}
          </>
        }
      />
    </div>
  );
}
